<template>
  <div class="header">
    <h1 class="header__logo">
      <HeaderImage name="logo" />
    </h1>
    <ul class="header__link">
      <li>
        <a href="/design-new/">
          <HeaderImage name="headerShirts" />
          デザイン一覧
        </a>
      </li>
      <li>
        <a href="/contact/" ref="hoge">
          <HeaderImage name="line" />
          お問い合わせ
        </a>
      </li>
    </ul>
  </div>
</template>

<script>
import HeaderImage from './images/HeaderImage'
export default {
  components: {
    HeaderImage
  }
}
</script>